import React, { useState } from 'react';
import MemoryBreakdownModal from './MemoryBreakdownModal';
import { Button, StatusIndicator } from '@amzn/awsui-components-react/polaris';
import MemoryBar from './MemoryBar';
import { BrokerInstanceMemoryBreakdown, EC2Instance } from '@amzn/amazonmq-opsconsole-client';

type Props = {
    instance: EC2Instance,
    instanceMemoryBreakdown: BrokerInstanceMemoryBreakdown

}
const BrokerInstanceMemoryBreakdownPanel : React.FC<Props> = ({instance, instanceMemoryBreakdown}) => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    if (instanceMemoryBreakdown.status === "FAILED") {
        return <StatusIndicator type='error'>Could not load memory breakdown</StatusIndicator>
    }
    return (
        <div>
            <span className='awsui-util-label'>Memory:</span>
            <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center'}}>
                <MemoryBreakdownModal
                    open={modalOpen}
                    instance={instance}
                    instanceMemoryBreakdown={instanceMemoryBreakdown}
                    onClose={() => {
                        setModalOpen(false);
                    }
                } />
                <MemoryBar data={instanceMemoryBreakdown} />
                <Button variant="icon" iconName="expand" onClick={() => {
                    setModalOpen(true);
                }} />
            </div>
        </div>
    )
}

export default BrokerInstanceMemoryBreakdownPanel;